import { clsx } from 'clsx';

import { BillingInfo, ClientInfoModule } from 'features/order/detail';
import { StoreAuditAlert } from 'features/order/store-audit/components';
import OrderDetailDialogActionsBox from '../order-detail-dialog-actions-box';
import { OrderDetailDialogCancellationBox } from '../order-detail-dialog-cancellation-box';
import { OrderDetailDialogCookingTimeSection } from '../order-detail-dialog-cooking-time-section';
import { OrderDetailDialogMarketplaceBox } from '../order-detail-dialog-marketplace-box';
import { OrderDetailDialogPickupBox } from '../order-detail-dialog-pickup-box';
import { OrderDetailDialogRTBox } from '../order-detail-dialog-rt-box';
import { CargoAdditionalRT } from '../../features/cargo';
import { OrderDeliveryDetail } from '../../features/order/delivery-detail';

import Hooks from './hooks';
import { orderDetailApp } from '../../business/order-mgmt';

import { HANDOFF_ADOPTION } from 'components/order-detail-dialog/domain';

import useStyles from './OrderDetailDialogMainSection.styles';

function OrderDetailDialogMainSection(props) {
  const {
    classes = {},
    showCancellationBox = false,
    showCookingTimeInputBox,
    showRTBox = false,
    orderId,
    storeId,
    orderStatus,
    deliveryMethod,
    isCookingTimeDisabled,
    showOrderDetailBox,
    productConfirmationCode,
    orderState,
    canEditOrderDetailBox,
    isFastOperation,
    isMandatory,
    isBagQuantitySet,
    hasDeliveryDetailMessage,
    hasDefectRate,
    userInfo,
  } = props;

  const _clases = useStyles();
  const showMarketplaceBox = Hooks.useShowMarketplaceBox();
  const showPickupBox = Hooks.useShowPickupBox();
  const { isTimeoutOrder } = orderDetailApp();
  const showCookingTime = showCookingTimeInputBox || isTimeoutOrder;
  const isDisabledCookingTime = isCookingTimeDisabled;
  const _showStoreAuditAlert = !showOrderDetailBox && hasDefectRate;

  return (
    <div className={clsx(_clases.root, classes?.root)}>
      <div className={clsx(_clases.itemsContainer, classes?.itemsContainer)}>
        <ClientInfoModule orderId={orderId} />
        {userInfo?.has_document_type && <BillingInfo userInfo={userInfo} />}
        {showCookingTime && (
          <OrderDetailDialogCookingTimeSection
            isDisabled={isDisabledCookingTime}
            isFastOperation={isFastOperation}
          />
        )}
        {showOrderDetailBox && (
          <div id={HANDOFF_ADOPTION}>
            <OrderDeliveryDetail
              code={productConfirmationCode}
              orderId={orderId}
              storeId={storeId}
              orderState={orderState}
              canEditOrderDetailBox={canEditOrderDetailBox}
              isMandatory={isMandatory}
              isBagQuantitySet={isBagQuantitySet}
              hasDeliveryDetailMessage={hasDeliveryDetailMessage}
              hasDefectRate={hasDefectRate}
            />
          </div>
        )}
        {_showStoreAuditAlert && (
          <StoreAuditAlert orderId={orderId} hasWrapper={true} />
        )}
        {showRTBox && <OrderDetailDialogRTBox />}
        {showCancellationBox && <OrderDetailDialogCancellationBox />}
        <CargoAdditionalRT
          behavior='detailMarketplace'
          storeId={storeId}
          orderId={orderId}
          orderStatus={orderStatus}
          deliveryMethod={deliveryMethod}
        />
        {showMarketplaceBox && <OrderDetailDialogMarketplaceBox />}
        {showPickupBox && <OrderDetailDialogPickupBox />}
      </div>
      <OrderDetailDialogActionsBox />
    </div>
  );
}

export default OrderDetailDialogMainSection;
